"use client"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  useTheme,
} from "@mui/material"
import WarningIcon from "@mui/icons-material/Warning"
import LaunchIcon from "@mui/icons-material/Launch"

const ConfirmNavigationModal = ({ open, onClose, onConfirm, destination, destinationName, isLogin }) => {
  const theme = useTheme()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "rgba(13, 15, 25, 0.95)",
          border: "1px solid rgba(0, 229, 255, 0.2)",
          borderRadius: 2,
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
          overflow: "hidden",
          maxWidth: "500px",
          width: "100%",
        },
      }}
    >
      {/* Decorative header */}
      <Box
        sx={{
          height: "8px",
          background: "linear-gradient(90deg, #00e5ff 0%, rgba(0, 229, 255, 0.3) 50%, rgba(0, 0, 0, 0) 100%)",
          width: "100%",
        }}
      />

      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          pb: 1,
        }}
      >
        <WarningIcon sx={{ color: theme.palette.warning.main }} />
        <Typography variant="h6" component="span" sx={{ fontWeight: "bold" }}>
          {isLogin ? "Discord Authentication" : "External Navigation"}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {isLogin ? (
          <>
            <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.8)", mb: 2 }}>
              You are about to be redirected to Discord to authenticate your account:
            </DialogContentText>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 2,
                borderRadius: 1,
                bgcolor: "rgba(0, 0, 0, 0.3)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                mb: 2,
              }}
            >
              <LaunchIcon sx={{ color: theme.palette.primary.main }} />
              <Typography
                variant="body1"
                component="span"
                sx={{
                  fontWeight: "medium",
                  color: theme.palette.primary.main,
                }}
              >
                Discord Authentication
              </Typography>
            </Box>
            <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
              This will allow DarkEdge to access your Discord username, avatar, and server membership information.
            </DialogContentText>
          </>
        ) : (
          <>
            <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.8)", mb: 2 }}>
              You are about to leave this site and navigate to:
            </DialogContentText>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 2,
                borderRadius: 1,
                bgcolor: "rgba(0, 0, 0, 0.3)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                mb: 2,
              }}
            >
              <LaunchIcon sx={{ color: theme.palette.primary.main }} />
              <Typography
                variant="body1"
                component="span"
                sx={{
                  fontWeight: "medium",
                  color: theme.palette.primary.main,
                }}
              >
                {destinationName || destination}
              </Typography>
            </Box>
            <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
              Are you sure you want to continue to this external website?
            </DialogContentText>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "rgba(255, 255, 255, 0.3)",
            color: "rgba(255, 255, 255, 0.7)",
            "&:hover": {
              borderColor: "rgba(255, 255, 255, 0.5)",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          endIcon={<LaunchIcon />}
          sx={{
            background: "linear-gradient(45deg, #00e5ff 30%, #2979ff 90%)",
            boxShadow: "0 0 10px rgba(0, 229, 255, 0.5)",
            "&:hover": {
              boxShadow: "0 0 15px rgba(0, 229, 255, 0.8)",
            },
          }}
        >
          {isLogin ? "Continue to Discord" : "Continue"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmNavigationModal
